
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6rDm4", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $9kbTQ = parcelRequire("9kbTQ");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $8d8gu = parcelRequire("8d8gu");

var $dghLx = parcelRequire("dghLx");


var $bA1GQ = parcelRequire("bA1GQ");


var $gIMcb = parcelRequire("gIMcb");


var $1tBud = parcelRequire("1tBud");


var $ieeJu = parcelRequire("ieeJu");


var $jkcNT = parcelRequire("jkcNT");




const $d0f2834cca6c5ad8$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    unableToLoadContent: {
        id: "fabric.editor.unableToLoadContent",
        defaultMessage: "We couldn't load this content"
    },
    failedToUpload: {
        id: "fabric.editor.failed_to_upload",
        defaultMessage: "Failed to upload"
    }
});



var $b8DpU = parcelRequire("b8DpU");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $8396x = parcelRequire("8396x");


var $9vt4W = parcelRequire("9vt4W");


var $bLufD = parcelRequire("bLufD");




/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic




var $lfoFx = parcelRequire("lfoFx");

/** Height threshold that determines icon size to be small or medium */ const $9b407d46b723d920$export$88e3664eef60c981 = 24;


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic



/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766



const $939b91c040d46974$export$c4d4f06a25de97f = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'inline-flex',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    boxDecorationBreak: 'clone',
    borderRadius: `${"var(--ds-radius-small, 3px)"}`,
    color: `${"var(--ds-text, #292A2E)"}`,
    backgroundColor: `${"var(--ds-background-neutral, #0515240F)"}`,
    transition: '0.1s all ease-in-out',
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: `${"var(--ds-background-neutral-hovered, #0B120E24)"}`
    }
});


const $a8f6f05798db5c3f$export$b89a827e9254211a = ({ children: children, testId: testId })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: (0, $939b91c040d46974$export$c4d4f06a25de97f),
        "data-testid": testId
    }, children);


const $548dcd32a9ea78c1$export$4b1a62d8f05056a7 = ({ testId: testId = 'media-inline-image-card-loading-view', height: height = (0, $9b407d46b723d920$export$88e3664eef60c981) })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $a8f6f05798db5c3f$export$b89a827e9254211a), {
        testId: testId
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lfoFx.default), {
        size: height > (0, $9b407d46b723d920$export$88e3664eef60c981) ? 'medium' : 'small',
        interactionName: "media-inline-spinner"
    }));
};


const $0f45fafb4e605e48$export$bb1dd14451154199 = ({ dimensions: dimensions, identifier: identifier, renderError: renderError, alt: alt, isLazy: isLazy, ssr: ssr, crop: crop, stretch: stretch })=>{
    // Generate unique traceId for file
    const traceContext = (0, $cozmU.useMemo)(()=>({
            traceId: (0, $8396x.getRandomHex)(8)
        }), []);
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO do we need to handle nonCriticalError
    const { preview: preview, error: previewError, onImageError: onImageError, onImageLoad: onImageLoad, getSsrScriptProps: getSsrScriptProps, copyNodeRef: copyNodeRef } = (0, $9vt4W.useFilePreview)({
        identifier: identifier,
        ssr: ssr,
        dimensions: dimensions,
        traceContext: traceContext
    });
    const memoizedOnImageLoad = (0, $cozmU.useCallback)(()=>{
        onImageLoad(preview);
    }, [
        onImageLoad,
        preview
    ]);
    if (previewError) return renderError({
        error: previewError
    });
    if (!preview) return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $548dcd32a9ea78c1$export$4b1a62d8f05056a7), null);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $bLufD.MediaImage), {
        dataURI: preview.dataURI,
        alt: alt,
        previewOrientation: preview.orientation,
        onImageLoad: (0, $ieeJu.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedOnImageLoad : ()=>{
            onImageLoad(preview);
        },
        onImageError: onImageError,
        loading: isLazy ? 'lazy' : undefined,
        forceSyncDisplay: !!ssr,
        crop: crop,
        stretch: stretch,
        ref: copyNodeRef
    }), getSsrScriptProps && // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $lOiVq.jsx)("script", getSsrScriptProps()));
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $czp8P = parcelRequire("czp8P");





var $kMQcj = parcelRequire("kMQcj");

function $53efe642f3d3e21e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// The MediaImage component needs to obtain its parent's dimensions.
// To achieve this, we have added an additional wrapper that allows
// for better interaction with the parent element. This is necessary
//  because the parent size changes its box-sizing with the node border.
const $53efe642f3d3e21e$var$sizeWrapperStyle = {
    name: "1ogmv4n",
    styles: "display:inline-flex;width:100%;height:100%"
};
const $53efe642f3d3e21e$export$8519fee8cc913056 = ({ children: children, isSelected: isSelected, aspectRatio: aspectRatio, borderSize: borderSize, borderColor: borderColor, htmlAttrs: htmlAttrs = {}, onClick: onClick })=>{
    const borderStyleVars = borderSize && borderColor ? {
        [(0, $kMQcj.INLINE_IMAGE_BORDER_SIZE_CSS_VAR_KEY)]: borderSize,
        [(0, $kMQcj.INLINE_IMAGE_BORDER_COLOR_CSS_VAR_KEY)]: (0, $czp8P.hexToEditorBorderPaletteColor)(borderColor) || borderColor
    } : {};
    const aspectStyleVars = aspectRatio ? {
        [(0, $kMQcj.INLINE_IMAGE_ASPECT_RATIO_CSS_VAR_KEY)]: aspectRatio
    } : {};
    const onKeyDown = (e)=>{
        if ((0, $ieeJu.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true)) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick(e);
            }
        }
        return undefined;
    };
    return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
    /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            ...borderStyleVars,
            ...aspectStyleVars
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $kMQcj.INLINE_IMAGE_WRAPPER_CLASS_NAME),
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $kMQcj.wrapperStyle),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            borderSize && borderColor && (0, $kMQcj.borderStyle),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isSelected && (0, $kMQcj.selectedStyle)
        ],
        "data-testid": "inline-image-wrapper",
        role: (0, $ieeJu.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? 'button' : undefined,
        tabIndex: (0, $ieeJu.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? 0 : undefined,
        onClick: onClick,
        onKeyDown: onKeyDown,
        ...htmlAttrs
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: $53efe642f3d3e21e$var$sizeWrapperStyle
    }, children)));
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic




var $lMGh1 = parcelRequire("lMGh1");


var $lpNn5 = parcelRequire("lpNn5");


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic



function $5422c295c90fed0c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5422c295c90fed0c$var$wrapperStyle = {
    name: "1xutr1y",
    styles: "display:flex;span > svg{vertical-align:top;}"
};
const $5422c295c90fed0c$export$be58b4326e23250f = ({ children: children })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: $5422c295c90fed0c$var$wrapperStyle,
        "data-testid": "media-inline-image-card-icon"
    }, children);
};


const $59d2b26520da7027$export$cbdc50f98f4f8d00 = ({ testId: testId = 'media-inline-image-card-error-view', message: message, icon: icon })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $a8f6f05798db5c3f$export$b89a827e9254211a), {
        testId: testId
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
        content: message,
        position: "top",
        tag: "span",
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $5422c295c90fed0c$export$be58b4326e23250f), null, icon || /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
        label: "error",
        color: "var(--ds-icon-danger, #C9372C)"
    }))));
};



const $6fa3381d8b22c178$export$5d2cd1bea8591ba3 = ({ mediaClient: mediaClient, identifier: identifier, isSelected: isSelected, intl: intl, alt: alt, isLazy: isLazy, width: width, height: height, border: border, ssr: ssr, serializeDataAttrs: serializeDataAttrs, shouldOpenMediaViewer: shouldOpenMediaViewer, isViewOnly: isViewOnly })=>{
    const [fileState, setFileState] = (0, $cozmU.useState)();
    const [subscribeError, setSubscribeError] = (0, $cozmU.useState)();
    const [isFailedEventSent, setIsFailedEventSent] = (0, $cozmU.useState)(false);
    const [isSucceededEventSent, setIsSucceededEventSent] = (0, $cozmU.useState)(false);
    const [isMediaViewerVisible, setMediaViewerVisible] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = intl || (0, $kSwu1.createIntl)({
        locale: 'en'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireFailedOperationalEvent = (error = new (0, $dghLx.MediaCardError)('missing-error-data'), failReason)=>{
        if (!isFailedEventSent && fileState) {
            setIsFailedEventSent(true);
            (0, $8d8gu.fireFailedOperationalEvent)(fileState, error, failReason, createAnalyticsEvent);
        }
    };
    const fireSucceededOperationalEvent = ()=>{
        if (!isSucceededEventSent && fileState) {
            setIsSucceededEventSent(true);
            (0, $8d8gu.fireSucceededOperationalEvent)(fileState, createAnalyticsEvent);
        }
    };
    (0, $cozmU.useEffect)(()=>{
        if (mediaClient) {
            const subscription = mediaClient.file.getFileState(identifier.id, {
                collectionName: identifier.collectionName
            }).subscribe({
                next: (fileState)=>{
                    setFileState(fileState);
                    setSubscribeError(undefined);
                },
                error: (e)=>{
                    setSubscribeError(e);
                }
            });
            return ()=>{
                subscription.unsubscribe();
            };
        }
    }, [
        identifier,
        mediaClient
    ]);
    const memoizedRenderError = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, $59d2b26520da7027$export$cbdc50f98f4f8d00), {
            message: formatMessage((0, $d0f2834cca6c5ad8$export$defe85febe8b728c).unableToLoadContent)
        }), [
        formatMessage
    ]);
    const content = (dimensions)=>{
        if (!mediaClient) return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $548dcd32a9ea78c1$export$4b1a62d8f05056a7), null);
        if (!ssr) {
            if (subscribeError) {
                const isUploading = fileState?.status === 'uploading';
                const errorMessage = isUploading ? (0, $d0f2834cca6c5ad8$export$defe85febe8b728c).failedToUpload : (0, $d0f2834cca6c5ad8$export$defe85febe8b728c).unableToLoadContent;
                const errorReason = fileState?.status === 'uploading' ? 'upload' : 'metadata-fetch';
                fireFailedOperationalEvent(new (0, $dghLx.MediaCardError)(errorReason, subscribeError));
                return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $59d2b26520da7027$export$cbdc50f98f4f8d00), {
                    message: formatMessage(errorMessage)
                });
            }
            if (!fileState || fileState?.status === 'uploading') return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $548dcd32a9ea78c1$export$4b1a62d8f05056a7), null);
            if (fileState.status === 'error') {
                fireFailedOperationalEvent(new (0, $dghLx.MediaCardError)('error-file-state', new Error(fileState.message)));
                return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $59d2b26520da7027$export$cbdc50f98f4f8d00), {
                    message: formatMessage((0, $d0f2834cca6c5ad8$export$defe85febe8b728c).unableToLoadContent)
                });
            } else if (fileState.status === 'failed-processing') {
                fireFailedOperationalEvent(undefined, 'failed-processing');
                return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $59d2b26520da7027$export$cbdc50f98f4f8d00), {
                    message: formatMessage((0, $d0f2834cca6c5ad8$export$defe85febe8b728c).unableToLoadContent)
                });
            } else if (!fileState.name) {
                fireFailedOperationalEvent(new (0, $dghLx.MediaCardError)('metadata-fetch', new (0, $bA1GQ.FileFetcherError)('emptyFileName', {
                    id: fileState.id
                })));
                return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $59d2b26520da7027$export$cbdc50f98f4f8d00), {
                    message: formatMessage((0, $d0f2834cca6c5ad8$export$defe85febe8b728c).unableToLoadContent)
                });
            }
            if (fileState.status === 'processed') fireSucceededOperationalEvent();
        }
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $gIMcb.MediaClientContext).Provider, {
            value: mediaClient
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $0f45fafb4e605e48$export$bb1dd14451154199), {
            dimensions: dimensions,
            identifier: identifier,
            renderError: (0, $ieeJu.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedRenderError : // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- intentional fallback for experiment off path
            ()=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, $59d2b26520da7027$export$cbdc50f98f4f8d00), {
                    message: formatMessage((0, $d0f2834cca6c5ad8$export$defe85febe8b728c).unableToLoadContent)
                }),
            alt: alt,
            ssr: ssr?.mode,
            isLazy: isLazy,
            crop: true,
            stretch: false
        }));
    };
    const aspectRatio = (0, $cozmU.useMemo)(()=>width && height ? width / height : undefined, [
        width,
        height
    ]);
    /**
   * scaledDimensions is used to define the correct media size fetched from media service
   * inline images will only ever be rendered at a maximum height of H1 and so scaled dimensions
   * will only ever return a width and height where the height has a maximum height of H1
   */ const scaledDimension = (0, $cozmU.useMemo)(()=>{
        if (!width || !height || !aspectRatio) return {
            width: width,
            height: height
        };
        return {
            width: Math.round(aspectRatio * (0, $b8DpU.referenceHeights)['h1']),
            height: (0, $b8DpU.referenceHeights)['h1']
        };
    }, [
        width,
        height,
        aspectRatio
    ]);
    const htmlAttributes = (0, $cozmU.useMemo)(()=>{
        if (serializeDataAttrs) {
            const resolvedAttrs = fileState && fileState.status !== 'error' ? {
                'data-file-size': fileState.size,
                'data-file-mime-type': fileState.mimeType,
                'data-file-name': fileState.name
            } : {};
            return {
                'data-type': 'image',
                'data-node-type': 'mediaInline',
                'data-id': identifier.id,
                'data-collection': identifier.collectionName,
                'data-width': width,
                'data-height': height,
                'data-alt': alt,
                ...resolvedAttrs
            };
        }
        return {};
    }, [
        alt,
        fileState,
        height,
        identifier,
        width,
        serializeDataAttrs
    ]);
    const onMediaInlineImageClick = (0, $cozmU.useCallback)((e)=>{
        if (shouldOpenMediaViewer) setMediaViewerVisible(true);
        // In edit mode (node content wrapper has contenteditable set to true), link redirection is disabled by default
        // We need to call "stopPropagation" here in order to prevent in editor view mode, the browser from navigating to
        // another URL if the media node is wrapped in a link mark.
        if (isViewOnly && (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1')) e.preventDefault();
    }, [
        shouldOpenMediaViewer,
        isViewOnly
    ]);
    const onMediaInlinePreviewClose = (0, $cozmU.useCallback)(()=>{
        setMediaViewerVisible(false);
    }, []);
    const memoizedMediaViewerItems = (0, $cozmU.useMemo)(()=>[
            identifier
        ], [
        identifier
    ]);
    const mediaViewer = (0, $cozmU.useMemo)(()=>{
        if (isMediaViewerVisible && mediaClient?.mediaClientConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).createPortal(/*#__PURE__*/ (0, $lOiVq.jsx)((0, $1tBud.default), {
            collectionName: identifier.collectionName || '',
            items: (0, $ieeJu.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedMediaViewerItems : // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- intentional fallback for experiment off path
            [
                identifier
            ],
            mediaClientConfig: mediaClient?.mediaClientConfig,
            selectedItem: identifier,
            onClose: onMediaInlinePreviewClose
        }), document.body);
        return null;
    }, [
        identifier,
        isMediaViewerVisible,
        mediaClient?.mediaClientConfig,
        onMediaInlinePreviewClose,
        memoizedMediaViewerItems
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $53efe642f3d3e21e$export$8519fee8cc913056), {
        isSelected: isSelected,
        aspectRatio: aspectRatio,
        borderColor: border?.borderColor,
        borderSize: border?.borderSize,
        htmlAttrs: htmlAttributes,
        onClick: onMediaInlineImageClick
    }, content(scaledDimension)), mediaViewer);
};
const $6fa3381d8b22c178$export$fca833ae4278270f = (0, $kSwu1.injectIntl)($6fa3381d8b22c178$export$5d2cd1bea8591ba3, {
    enforceContext: false
});
module.exports["MediaInlineImageCard"] = $6fa3381d8b22c178$export$fca833ae4278270f;

});

parcelRegister("8d8gu", function(module, exports) {

var $2rF8G = parcelRequire("2rF8G");


var $dghLx = parcelRequire("dghLx");

const $c7c7411d5ae3be78$export$95e48cf5f4b392a4 = (fileState)=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaInlineRender',
        attributes: {
            status: 'success',
            fileAttributes: {
                fileId: fileState?.id || '',
                fileSize: fileState?.size,
                fileMediatype: fileState?.mediaType,
                fileMimetype: fileState?.mimeType,
                fileStatus: fileState?.status
            }
        }
    };
};
const $c7c7411d5ae3be78$export$b37f976ad373d2e0 = (fileId, error, fileState)=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaInlineRender',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId,
                fileStatus: fileState?.status
            },
            ...(0, $2rF8G.extractErrorInfo)(error)
        }
    };
};
const $c7c7411d5ae3be78$export$d0b5daf3b6a26055 = (fileId, fileState, processingFailReason)=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaInlineRender',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId,
                fileStatus: fileState?.status
            },
            failReason: 'failed-processing',
            // 'not-available' is used for cases before processingFailReason implementation (backward compatibility)
            processingFailReason: processingFailReason || 'not-available'
        }
    };
};
const $c7c7411d5ae3be78$export$d66a74eca3334206 = (fileState, error = new (0, $dghLx.MediaCardError)('missing-error-data'), failReason, createAnalyticsEvent)=>{
    // Extract processingFailReason from fileState if available
    const processingFailReason = fileState?.status === 'failed-processing' ? fileState.failReason : undefined;
    const payload = failReason ? $c7c7411d5ae3be78$export$d0b5daf3b6a26055(fileState?.id || 'unknown-id', fileState, processingFailReason) : $c7c7411d5ae3be78$export$b37f976ad373d2e0(fileState?.id || 'unknown-id', error, fileState);
    (0, $2rF8G.fireMediaCardEvent)(payload, createAnalyticsEvent);
};
const $c7c7411d5ae3be78$export$3bc90882cb04fda4 = (fileState, createAnalyticsEvent)=>{
    const payload = $c7c7411d5ae3be78$export$95e48cf5f4b392a4(fileState);
    (0, $2rF8G.fireMediaCardEvent)(payload, createAnalyticsEvent);
};
module.exports["getSucceededStatusPayload"] = $c7c7411d5ae3be78$export$95e48cf5f4b392a4;
module.exports["getErrorStatusPayload"] = $c7c7411d5ae3be78$export$b37f976ad373d2e0;
module.exports["getFailedProcessingStatusPayload"] = $c7c7411d5ae3be78$export$d0b5daf3b6a26055;
module.exports["fireFailedOperationalEvent"] = $c7c7411d5ae3be78$export$d66a74eca3334206;
module.exports["fireSucceededOperationalEvent"] = $c7c7411d5ae3be78$export$3bc90882cb04fda4;

});

parcelRegister("ilHsf", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aOKgt = parcelRequire("aOKgt");


var $gBjHb = parcelRequire("gBjHb");




class $e8d56cfbd05efd87$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    async componentDidMount() {
        this.mounted = true;
        if (!this.state.MediaInlineCard) try {
            const [mediaClient, cardModule, mediaInlineErrorBoundaryModule] = await Promise.all([
                (parcelRequire("9nfUk")),
                (parcelRequire("haNST")),
                (parcelRequire("hiiqQ"))
            ]);
            $e8d56cfbd05efd87$export$2e2bcd8739ae039.MediaInlineCard = mediaClient.withMediaClient(cardModule.MediaInlineCard);
            $e8d56cfbd05efd87$export$2e2bcd8739ae039.ErrorBoundary = mediaInlineErrorBoundaryModule.default;
            if (this.mounted) this.setState({
                MediaInlineCard: $e8d56cfbd05efd87$export$2e2bcd8739ae039.MediaInlineCard,
                ErrorBoundary: $e8d56cfbd05efd87$export$2e2bcd8739ae039.ErrorBoundary
            });
        } catch (error) {}
    }
    async componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        const { MediaInlineCard: MediaInlineCard, ErrorBoundary: ErrorBoundary } = this.state;
        const analyticsContext = {
            packageVersion: "platform-pkg",
            packageName: "0.0.0-use.local",
            componentName: 'mediaInlineCard',
            component: 'mediaInlineCard'
        };
        if (!MediaInlineCard || !ErrorBoundary) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aOKgt.MediaInlineCardLoadingView), {
            message: ""
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
            data: analyticsContext
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ErrorBoundary, {
            isSelected: this.props.isSelected
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(MediaInlineCard, this.props)));
    }
    constructor(...args){
        super(...args);
        this.mounted = false;
        this.state = {
            MediaInlineCard: $e8d56cfbd05efd87$export$2e2bcd8739ae039.MediaInlineCard,
            ErrorBoundary: $e8d56cfbd05efd87$export$2e2bcd8739ae039.ErrorBoundary
        };
    }
}
$e8d56cfbd05efd87$export$2e2bcd8739ae039.displayName = 'MediaInlineCardLoader';
$e8d56cfbd05efd87$export$2e2bcd8739ae039.MediaInlineCard = void 0;
$e8d56cfbd05efd87$export$2e2bcd8739ae039.ErrorBoundary = void 0;
module.exports["default"] = $e8d56cfbd05efd87$export$2e2bcd8739ae039;

});

parcelRegister("aOKgt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lfoFx = parcelRequire("lfoFx");


var $jmwng = parcelRequire("jmwng");


var $16ZNV = parcelRequire("16ZNV");


var $7CDH1 = parcelRequire("7CDH1");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");














var $hekY6 = parcelRequire("hekY6");

const $ea3c794bd38f29b0$var$rightIconPositionWrapperStyles = null;
const $ea3c794bd38f29b0$export$91b164375b8037b5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_2XsHFMFQfX _0adFHs1Y8M _1mT5xdRAKS _3iDTPbvbI6"
        ]);
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== children || $[5] !== props) {
        t2 = /*#__PURE__*/ $cozmU.createElement("span", {
            ...props,
            className: t1
        }, children);
        $[4] = children;
        $[5] = props;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ children: children, ...props })=>/*#__PURE__*/ $cozmU.createElement("span", {
        ...props,
        className: (0, $hekY6.default)([
            "_2XsHFMFQfX _0adFHs1Y8M _1mT5xdRAKS _3iDTPbvbI6"
        ])
    }, children);


const $44bcdccba26bfd92$export$91b164375b8037b5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ea3c794bd38f29b0$export$91b164375b8037b5), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ea3c794bd38f29b0$export$91b164375b8037b5), props);























const $21daeafc3d2b78e3$var$spinnerWrapperStyles = null;
const $21daeafc3d2b78e3$export$52b4dfd89a6b3a1b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1ANEUSlpBW _3W2Oc84hR5 _1RrJLiQame _2XsHFMFQfX"
        ]);
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== children || $[5] !== props) {
        t2 = /*#__PURE__*/ $cozmU.createElement("span", {
            ...props,
            className: t1
        }, children);
        $[4] = children;
        $[5] = props;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ children: children, ...props })=>/*#__PURE__*/ $cozmU.createElement("span", {
        ...props,
        className: (0, $hekY6.default)([
            "_1ANEUSlpBW _3W2Oc84hR5 _1RrJLiQame _2XsHFMFQfX"
        ])
    }, children);


const $6446b6b7f9244ae0$export$52b4dfd89a6b3a1b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $21daeafc3d2b78e3$export$52b4dfd89a6b3a1b), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $21daeafc3d2b78e3$export$52b4dfd89a6b3a1b), props);


class $bac4af1fb7ce695f$export$4449fcbb2ad61ad1 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        const { message: message, onClick: onClick, isSelected: isSelected, inlinePreloaderStyle: inlinePreloaderStyle, innerRef: innerRef, testId: testId = 'media-inline-card-loading-view' } = this.props;
        if (inlinePreloaderStyle === 'on-right-without-skeleton') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jmwng.Frame), {
            innerRef: innerRef,
            testId: testId,
            onClick: onClick,
            isSelected: isSelected
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7CDH1.IconTitleWrapper), null, message, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $44bcdccba26bfd92$export$91b164375b8037b5), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6446b6b7f9244ae0$export$52b4dfd89a6b3a1b), {
            className: "inline-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: 14,
            interactionName: "media-inline-card-loading-view"
        })))));
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jmwng.Frame), {
            innerRef: innerRef,
            testId: testId,
            onClick: onClick,
            isSelected: isSelected
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $16ZNV.IconAndTitleLayout), {
            title: message
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6446b6b7f9244ae0$export$52b4dfd89a6b3a1b), {
            className: "inline-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: 14,
            interactionName: "media-inline-card-loading-view"
        }))));
    }
}
module.exports["MediaInlineCardLoadingView"] = $bac4af1fb7ce695f$export$4449fcbb2ad61ad1;

});

parcelRegister("jmwng", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");











var $hekY6 = parcelRequire("hekY6");




const $0e4fb31914270a0d$var$selectedStyles = null;
const $0e4fb31914270a0d$var$notSelectedStyles = null;
const $0e4fb31914270a0d$var$errorStyles = null;
const $0e4fb31914270a0d$var$wrapperStyles = null; /*
                              Media Inline cards should have the following layout:
                              -----------------
                              | icon | title |
                              -----------------
                              The aim is to ensure (1) all children are
                              in line with each other, (2) are vertically
                              centered.
                            */ 
const $0e4fb31914270a0d$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(14);
    let children;
    let isError;
    let isSelected;
    let props;
    if ($[0] !== t0) {
        ({ isSelected: isSelected, isError: isError, children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = isError;
        $[3] = isSelected;
        $[4] = props;
    } else {
        children = $[1];
        isError = $[2];
        isSelected = $[3];
        props = $[4];
    }
    const t1 = isSelected && "_2xIroY98eZ _497WNwYbGa _2zndICT6kp _3vBAKHjOvk _0wOv4Q7zJH _2OUyjt2o41 _20VacPYbGa _00uqCY98eZ _3WzCGi98eZ _32C2rk98eZ _0DCa9D98eZ _3xtjKNYbGa _0NqVRtYbGa _0i9AWAYbGa _3932vvYbGa _0H9qDF6wH8 _3BKYwu6wH8 _0mm6KQ6wH8 _02cRtH6wH8";
    const t2 = !isSelected && "_20VacPJxkL";
    const t3 = isError && "_0KLXruhH7k _0wOv4Q18ZR _1eOmH6hH7k";
    let t4;
    if ($[5] !== t1 || $[6] !== t2 || $[7] !== t3) {
        t4 = (0, $hekY6.default)([
            "_0bjKvDzXzM _23rrnHwQNr _26BoRwey7F _0Of8r2FQfX _1Znuxb1Y8M _1wydGWFQfX _2Zuz6Q1Y8M _2NnhnEXpc7 _3iDTPbS8kF _1UtDYzy7kJ _0KLXruDMqu _4cb4toYbGa _0wOv4Q7zJH _1eOmH6KcZT",
            t1,
            t2,
            t3
        ]);
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== children || $[10] !== props || $[11] !== ref || $[12] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            ref: ref,
            "data-testid": "frame-wrapper",
            ...props,
            className: t4
        }, children);
        $[9] = children;
        $[10] = props;
        $[11] = ref;
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    return t5;
} : ({ isSelected: isSelected, isError: isError, children: children, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        ref: ref,
        "data-testid": "frame-wrapper",
        ...props,
        className: (0, $hekY6.default)([
            "_0bjKvDzXzM _23rrnHwQNr _26BoRwey7F _0Of8r2FQfX _1Znuxb1Y8M _1wydGWFQfX _2Zuz6Q1Y8M _2NnhnEXpc7 _3iDTPbS8kF _1UtDYzy7kJ _0KLXruDMqu _4cb4toYbGa _0wOv4Q7zJH _1eOmH6KcZT",
            isSelected && "_2xIroY98eZ _497WNwYbGa _2zndICT6kp _3vBAKHjOvk _0wOv4Q7zJH _2OUyjt2o41 _20VacPYbGa _00uqCY98eZ _3WzCGi98eZ _32C2rk98eZ _0DCa9D98eZ _3xtjKNYbGa _0NqVRtYbGa _0i9AWAYbGa _3932vvYbGa _0H9qDF6wH8 _3BKYwu6wH8 _0mm6KQ6wH8 _02cRtH6wH8",
            !isSelected && "_20VacPJxkL",
            isError && "_0KLXruhH7k _0wOv4Q18ZR _1eOmH6hH7k"
        ])
    }, children));


const $c6b98bc0bae7ffef$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0e4fb31914270a0d$export$e6dfd72ab29f8598), {
            ...props,
            ref: ref
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0e4fb31914270a0d$export$e6dfd72ab29f8598), {
        ...props,
        ref: ref
    }));


class $1e058550a3c9a399$export$b89a827e9254211a extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        const { isSelected: isSelected, children: children, onClick: onClick, innerRef: innerRef, testId: testId, isError: isError } = this.props;
        const isInteractive = Boolean(onClick);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c6b98bc0bae7ffef$export$e6dfd72ab29f8598), {
            ref: innerRef,
            isSelected: isSelected,
            isError: isError,
            tabIndex: isInteractive ? 0 : undefined,
            role: isInteractive ? 'button' : undefined,
            onClick: this.handleClick,
            onKeyPress: this.handleKeyPress,
            "data-testid": testId
        }, children);
    }
    constructor(...args){
        super(...args);
        this.handleClick = (event)=>{
            const { onClick: onClick } = this.props;
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick(event);
            }
        };
        this.handleKeyPress = (event)=>{
            if (event.key !== ' ' && event.key !== 'Enter') return;
            const { onClick: onClick } = this.props;
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick(event);
            }
        };
    }
}
module.exports["Frame"] = $1e058550a3c9a399$export$b89a827e9254211a;

});

parcelRegister("16ZNV", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6Eovk = parcelRequire("6Eovk");


var $kTb7m = parcelRequire("kTb7m");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");














var $hekY6 = parcelRequire("hekY6");

const $fd5655f57b49ebcb$var$iconStyles = null;
const $fd5655f57b49ebcb$export$f04a61298a47a40f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    let alt;
    let props;
    if ($[0] !== t0) {
        ({ alt: alt, ...props } = t0);
        $[0] = t0;
        $[1] = alt;
        $[2] = props;
    } else {
        alt = $[1];
        props = $[2];
    }
    const t1 = alt || "icon";
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_0bjKvDcjp5 _0jFU0VEbN9 _39xV02EbN9 _0adFHs1Y8M _20VacPYbGa _1mT5xdWVPG _2IhTon715P _3OE6xY715P _1VJPcaiDnZ"
        ]);
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== props || $[5] !== t1) {
        t3 = /*#__PURE__*/ $cozmU.createElement("img", {
            alt: t1,
            ...props,
            className: t2
        });
        $[4] = props;
        $[5] = t1;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ alt: alt, ...props })=>/*#__PURE__*/ $cozmU.createElement("img", {
        alt: alt || 'icon',
        ...props,
        className: (0, $hekY6.default)([
            "_0bjKvDcjp5 _0jFU0VEbN9 _39xV02EbN9 _0adFHs1Y8M _20VacPYbGa _1mT5xdWVPG _2IhTon715P _3OE6xY715P _1VJPcaiDnZ"
        ])
    });


const $f3e845695dccddb3$export$f04a61298a47a40f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fd5655f57b49ebcb$export$f04a61298a47a40f), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fd5655f57b49ebcb$export$f04a61298a47a40f), props);























const $45781cda0fcee680$var$iconObjectOverrideStyles = null; // TODO: remove this override behaviour for @atlaskit/icon
const $45781cda0fcee680$var$iconOverrideStyles = null;
const $45781cda0fcee680$var$emojiWrapperStyles = null; // Wraps all emoji in Inline Links similar to icon
const $45781cda0fcee680$export$e31a6cc0a4c97f0e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_3iDTPbvbI6 _0adFHsFQfX _20VacPYbGa",
            "_3mHFB0ey7F _1xqa3lEbN9 _0hRZngWVPG _1APnEMdnbC _0e714odnbC _2k03WtEbN9 _3pHI2TWVPG _0RmAnV715P _3uxJOt715P _2WxOoNiDnZ",
            "_04T49Yey7F _1dJRSsEbN9 _1p6MXrWVPG _3IFeDodnbC _4EhXnLdnbC _2LwLSJWVPG _1kUJHi715P _4l5alM715P _1IPGDKiDnZ"
        ]);
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== children || $[5] !== props) {
        t2 = /*#__PURE__*/ $cozmU.createElement("span", {
            ...props,
            className: t1
        }, children);
        $[4] = children;
        $[5] = props;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ children: children, ...props })=>/*#__PURE__*/ $cozmU.createElement("span", {
        ...props,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _0adFHsFQfX _20VacPYbGa",
            "_3mHFB0ey7F _1xqa3lEbN9 _0hRZngWVPG _1APnEMdnbC _0e714odnbC _2k03WtEbN9 _3pHI2TWVPG _0RmAnV715P _3uxJOt715P _2WxOoNiDnZ",
            "_04T49Yey7F _1dJRSsEbN9 _1p6MXrWVPG _3IFeDodnbC _4EhXnLdnbC _2LwLSJWVPG _1kUJHi715P _4l5alM715P _1IPGDKiDnZ"
        ])
    }, children);


const $1a49dc7ef03fa23a$export$e31a6cc0a4c97f0e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $45781cda0fcee680$export$e31a6cc0a4c97f0e), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $45781cda0fcee680$export$e31a6cc0a4c97f0e), props);























const $6ce76425aaf8b69b$var$iconEmptyWrapperStyles = null;
const $6ce76425aaf8b69b$export$ddce81e032b0736e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_39xV02EbN9 _0jFU0VN91d _3iDTPbvbI6 _1YKVNsdnbC"
        ]);
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== children || $[5] !== props) {
        t2 = /*#__PURE__*/ $cozmU.createElement("span", {
            ...props,
            className: t1
        }, children);
        $[4] = children;
        $[5] = props;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ children: children, ...props })=>/*#__PURE__*/ $cozmU.createElement("span", {
        ...props,
        className: (0, $hekY6.default)([
            "_39xV02EbN9 _0jFU0VN91d _3iDTPbvbI6 _1YKVNsdnbC"
        ])
    }, children);


const $c87cbc2c86150681$export$ddce81e032b0736e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ce76425aaf8b69b$export$ddce81e032b0736e), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ce76425aaf8b69b$export$ddce81e032b0736e), props);























const $03abfec1fc74ecaa$var$iconPositionWrapperStyles = null; // The following components are used to absolutely position icons in the vertical center.
const $03abfec1fc74ecaa$export$7291f9f954790243 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_0adFHs1Y8M _1mT5xdRAKS _3iDTPbvbI6"
        ]);
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== children || $[5] !== props) {
        t2 = /*#__PURE__*/ $cozmU.createElement("span", {
            ...props,
            className: t1
        }, children);
        $[4] = children;
        $[5] = props;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ children: children, ...props })=>/*#__PURE__*/ $cozmU.createElement("span", {
        ...props,
        className: (0, $hekY6.default)([
            "_0adFHs1Y8M _1mT5xdRAKS _3iDTPbvbI6"
        ])
    }, children);


const $e666fed6bef79371$export$7291f9f954790243 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $03abfec1fc74ecaa$export$7291f9f954790243), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $03abfec1fc74ecaa$export$7291f9f954790243), props);



var $7CDH1 = parcelRequire("7CDH1");






















const $1255b99c8d997b89$var$iconObjectOverrideStyles = null; // TODO: remove this override behaviour for @atlaskit/icon
const $1255b99c8d997b89$var$iconOverrideStyles = null;
const $1255b99c8d997b89$var$iconWrapperStyles = null; // Wraps all icons represented in Inline Links. Icons have three sources/types:
const $1255b99c8d997b89$export$be58b4326e23250f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_20VacPYbGa",
            "_3mHFB0ey7F _1xqa3lEbN9 _0hRZngWVPG _1APnEMdnbC _0e714odnbC _2k03WtEbN9 _3pHI2TWVPG _0RmAnV715P _3uxJOt715P _2WxOoNiDnZ",
            "_04T49Yey7F _1dJRSsEbN9 _1p6MXrWVPG _3IFeDodnbC _4EhXnLdnbC _2LwLSJWVPG _1kUJHi715P _4l5alM715P _1IPGDKiDnZ"
        ]);
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== children || $[5] !== props) {
        t2 = /*#__PURE__*/ $cozmU.createElement("span", {
            ...props,
            className: t1
        }, children);
        $[4] = children;
        $[5] = props;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ children: children, ...props })=>/*#__PURE__*/ $cozmU.createElement("span", {
        ...props,
        className: (0, $hekY6.default)([
            "_20VacPYbGa",
            "_3mHFB0ey7F _1xqa3lEbN9 _0hRZngWVPG _1APnEMdnbC _0e714odnbC _2k03WtEbN9 _3pHI2TWVPG _0RmAnV715P _3uxJOt715P _2WxOoNiDnZ",
            "_04T49Yey7F _1dJRSsEbN9 _1p6MXrWVPG _3IFeDodnbC _4EhXnLdnbC _2LwLSJWVPG _1kUJHi715P _4l5alM715P _1IPGDKiDnZ"
        ])
    }, children);


const $2785cd1d2543c409$export$be58b4326e23250f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1255b99c8d997b89$export$be58b4326e23250f), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1255b99c8d997b89$export$be58b4326e23250f), props);


class $6714215da4b1fa20$export$d34be4d513116847 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    renderAtlaskitIcon() {
        const { icon: icon, emoji: emoji } = this.props;
        if (emoji) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1a49dc7ef03fa23a$export$e31a6cc0a4c97f0e), null, emoji);
        if (!icon || typeof icon === 'string') return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2785cd1d2543c409$export$be58b4326e23250f), null, icon);
    }
    renderImageIcon(errored, testId) {
        const { icon: url } = this.props;
        if (!url || typeof url !== 'string') return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Eovk.default), {
            src: url,
            loaded: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f3e845695dccddb3$export$f04a61298a47a40f), {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: "smart-link-icon",
                src: url,
                "data-testid": `${testId}-image`
            }),
            errored: errored
        });
    }
    renderIconPlaceholder(testId) {
        const { defaultIcon: defaultIcon } = this.props;
        if (defaultIcon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2785cd1d2543c409$export$be58b4326e23250f), null, defaultIcon);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2785cd1d2543c409$export$be58b4326e23250f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
            color: "currentColor",
            label: "link",
            testId: `${testId}-default`
        }));
    }
    renderIcon(testId) {
        // We render two kinds of icons here:
        // - Image: acquired from either DAC or Teamwork Platform Apps;
        // - Atlaskit Icon: an Atlaskit SVG;
        // Each of these are scaled down to 12x12.
        const icon = this.renderAtlaskitIcon();
        if (icon) return icon;
        const placeholder = this.renderIconPlaceholder(testId);
        const image = this.renderImageIcon(placeholder, testId);
        return image || placeholder;
    }
    render() {
        const { children: children, title: title, titleColor: titleColor, testId: testId = 'media-inline-card-icon-and-title' } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7CDH1.IconTitleWrapper), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: titleColor ? {
                color: titleColor
            } : undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e666fed6bef79371$export$7291f9f954790243), null, children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c87cbc2c86150681$export$ddce81e032b0736e), null), this.renderIcon(testId))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "data-test-id": "title"
        }, title)));
    }
}
module.exports["IconAndTitleLayout"] = $6714215da4b1fa20$export$d34be4d513116847;

});

parcelRegister("9nfUk", function(module, exports) {

let $6d3299f2ee9f00e4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6d3299f2ee9f00e4$var$load("4KIrO"),
    $6d3299f2ee9f00e4$var$load("1AWvt"),
    $6d3299f2ee9f00e4$var$load("kruxh")
]).then(()=>parcelRequire('gB7FN'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("haNST", function(module, exports) {

let $c80a10d6632cee33$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c80a10d6632cee33$var$load("6OMo6"),
    $c80a10d6632cee33$var$load("aaRXj"),
    $c80a10d6632cee33$var$load("fHlIz"),
    $c80a10d6632cee33$var$load("4QwAJ"),
    $c80a10d6632cee33$var$load("3i44s"),
    $c80a10d6632cee33$var$load("5kI0b"),
    $c80a10d6632cee33$var$load("kYkz1"),
    $c80a10d6632cee33$var$load("jfYeU"),
    $c80a10d6632cee33$var$load("b4nm1"),
    $c80a10d6632cee33$var$load("geXPZ"),
    $c80a10d6632cee33$var$load("aQ5uu"),
    $c80a10d6632cee33$var$load("7EorR"),
    $c80a10d6632cee33$var$load("kHnae"),
    $c80a10d6632cee33$var$load("jTOhL"),
    $c80a10d6632cee33$var$load("jOE2W"),
    $c80a10d6632cee33$var$load("cuNBo"),
    $c80a10d6632cee33$var$load("4Ldt2"),
    $c80a10d6632cee33$var$load("2XRLb"),
    $c80a10d6632cee33$var$load("gkVge"),
    $c80a10d6632cee33$var$load("io0qR"),
    $c80a10d6632cee33$var$load("3MJxZ"),
    $c80a10d6632cee33$var$load("kHMR7"),
    $c80a10d6632cee33$var$load("e3OZZ"),
    $c80a10d6632cee33$var$load("cL682"),
    $c80a10d6632cee33$var$load("4MePG"),
    $c80a10d6632cee33$var$load("5JWJI"),
    $c80a10d6632cee33$var$load("ehicF")
]).then(()=>parcelRequire('6OauH'));

});

parcelRegister("hiiqQ", function(module, exports) {

let $c9726a4b33f951a4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c9726a4b33f951a4$var$load("9MojA").then(()=>parcelRequire('lSfec'));

});

parcelRegister("7CDH1", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $agSCl = parcelRequire("agSCl");

const $a74cf1e8ea3404f6$export$c73a53738ef9e3f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $agSCl.IconTitleWrapper), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $agSCl.IconTitleWrapper), props);
module.exports["IconTitleWrapper"] = $a74cf1e8ea3404f6$export$c73a53738ef9e3f;

});

parcelRegister("agSCl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $61e3f8aef92cb8ba$var$iconTitleWrapperStyles = null; // The main 'wrapping' element, title of the content.
const $61e3f8aef92cb8ba$export$c73a53738ef9e3f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1ANEUSlpBW _3W2Oc84hR5"
        ]);
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== children || $[5] !== props) {
        t2 = /*#__PURE__*/ $cozmU.createElement("span", {
            ...props,
            className: t1
        }, children);
        $[4] = children;
        $[5] = props;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ children: children, ...props })=>/*#__PURE__*/ $cozmU.createElement("span", {
        ...props,
        className: (0, $hekY6.default)([
            "_1ANEUSlpBW _3W2Oc84hR5"
        ])
    }, children);
module.exports["IconTitleWrapper"] = $61e3f8aef92cb8ba$export$c73a53738ef9e3f;

});


//# sourceMappingURL=mediaInline.cf929f3f.js.map
